// extracted by mini-css-extract-plugin
export default {"search":"Search_search__fJEPN","searchIcon":"Search_searchIcon__dB3wS"};